import Granbury1 from '../../../Media/Cibubur/Monte Verde.webp'
import Granbury2 from '../../../Media/Cibubur/Monte Verde.webp'


const Granburyimages =[
Granbury1,Granbury2
]

export default Granburyimages;